export default {
    // Note the various 'xxValue' properties below are NOT case-senstive (ie, all
    // searches and comparisons are done in a case in-sensitive way).
    defaultMapProfile: 'default-map.json',
    defaultStateProfile: 'default-state.json',
    defaultFacilityProfile: 'default-facility.json',
    profileApiAxiosConfig: {
        baseURL: 'https://mapqa.nexteraenergy.com/config/'
    },
    globalFactsheet: 'Global',
    applicationUrl: 'https://mapqa.nexteraenergy.com/index.html',
    printPdfUrlConfig: {
        baseURL: 'https://mapqa.nexteraenergy.com/',
        timeout: 90000
    },
    factSheetModelApiAxiosConfig: {
        baseURL: 'https://mapqa.nexteraenergy.com/config/data/',
        promoLines: 4
    },
    factSheetContentApiProps: {
        url: 'http://localhost/nex-content'
    },
    assetTypeApiProps: {
        url:
            'https://services5.arcgis.com/I77MVaEJQYkpWwzB/ArcGIS/rest/services/Nextera_Projects/FeatureServer/0?f=pjson',
        pipeline:
            'https://services5.arcgis.com/I77MVaEJQYkpWwzB/ArcGIS/rest/services/Nextera_Projects/FeatureServer/3?f=pjson',
        transmission:
            'https://services5.arcgis.com/I77MVaEJQYkpWwzB/ArcGIS/rest/services/Nextera_Projects/FeatureServer/2?f=pjson'
    },
    countryData: {
        outFields: [
            'COUNTRY_NAME',
            'TOTAL_CAPITAL_INVESTMENT',
            'NO_OF_JOBS',
            'ANNUAL_PAYROLL',
            'ANNUAL_PROPERTY_TAXES',
            'ANNUAL_LEASE_PAYMENTS',
            'MARKET_SHARE_SOLD',
            'NO_OF_EMPLOYEES',
            'PEOPLE_SERVED',
            'CUSTOMER_ACCOUNTS',
            'PRIMARY_COMPANY',
            'SECONDARY_COMPANY',
            'PRIMARY_LOGO',
            'SECONDARY_LOGO',
            'PRIMARY_WEB_ADDRESS',
            'SECONDARY_WEB_ADDRESS',
            'TITLE',
            'INTRO',
            'IMAGE',
            'IMAGE_CAPTION',
            'DISCLAIMER'
        ]
    },
    techData: {
        outFields: [
            'FUEL_TYPE_DESC',
            'TITLE',
            'IMAGE',
            'OVERVIEW',
            'BENEFITS',
            'DISCLAIMER1',
            'DISCLAIMER2',
            'DISCLAIMER3'
        ]
    },
    locationApiProps: {
        url:
            'https://services5.arcgis.com/I77MVaEJQYkpWwzB/ArcGIS/rest/services/Nextera_Projects/FeatureServer/4',
        where: 'FACILITIES=1',
        stateField: 'STATE_NAME',
        countryField: 'COUNTRY_NAME',
        facilitiesField: 'FACILITIES',
        usaCountryValue: 'USA',
        canadaCountryValue: 'Canada',
        hawaiiStateValue: 'Hawaii',
        extentOverrides: [
            {
                name: 'Hawaii',
                extent: {
                    xmin: -18264475,
                    ymin: 1921638,
                    xmax: -16827456,
                    ymax: 2769173,
                    spatialReference: {
                        wkid: 102100
                    }
                }
            }
        ],
        extentExpandFactor: 1.2
    },
    facilityApiProps: {
        url:
            'https://services5.arcgis.com/I77MVaEJQYkpWwzB/ArcGIS/rest/services/Nextera_Projects/FeatureServer/0',
        where: '1=1',
        nameField: 'PROJECT_NAME',
        stateField: 'STATE_NAME',
        countryField: 'COUNTRY_NAME',
        statusTypeWhere: 'PROJECT_STATUS IS NOT NULL',
        statusTypeField: 'PROJECT_STATUS',
        usaCountryValue: 'USA',
        canadaCountryValue: 'Canada',
        hawaiiStateValue: 'Hawaii',
        facilityExtentExpandFactor: 1.2,
        globalExtentExpandFactor: 1.5,
        usaExtentExpandFactor: 1.2,
        canadaExtentExpandFactor: 1.2,
        facilityTableDataFields: {
            country: 'COUNTRY_NAME',
            state: 'STATE_NAME',
            county: 'COUNTY_NAME',
            status: 'PROJECT_STATUS',
            asset: 'FUEL_TYPE_DESC',
            facilityName: 'PROJECT_NAME',
            district: 'US_CONG_DISTRICT',
            image: 'FACILITY_IMAGE',
            mw: 'MW',
            capacity: 'CAPACITY',
            contractedCapcity: 'CONTRACTED_CAPACITY',
            pipeline: 'PIPELINE_MILES',
            wells: 'WELLS',
            barrels: 'BARRELS',
            circuitmiles: 'TRANS_CIRCUIT_MILES',
            voltage: 'VOLTAGE',
            cufeet: 'CUBIC_FEET'
        }
    },
    countriesApiProps: {
        url:
            'https://services5.arcgis.com/I77MVaEJQYkpWwzB/ArcGIS/rest/services/Nextera_Projects/FeatureServer/7',
        where: '1=1',
        countryField: 'COUNTRY_NAME',
        usaCountryValue: 'USA',
        canadaCountryValue: 'Canada',
        globalCountryValue: 'Global'
    },
    techDataApiProps: {
        url:
            'https://services5.arcgis.com/I77MVaEJQYkpWwzB/ArcGIS/rest/services/Nextera_Projects/FeatureServer/8',
        where: '1=1',
        dataType: 'FUEL_TYPE_DESC'
    },
    filterColumns: {
        assetType: 'FUEL_TYPE_DESC',
        statusType: 'PROJECT_STATUS'
    },
    assetTypeSortOrder: {
        'Wind Energy': 'Wind',
        'Universal, Large-scale Solar': 'Solar Universal',
        'Small-scale, Distributed Solar': 'Solar Small-scale ',
        'Battery Storage': 'Battery Energy Storage',
        'Natural Gas Power Plants': 'Natural Gas',
        'Natural Gas Drilling Assets': 'Natural Gas Drilling',
        'Nuclear Power Plants': 'Nuclear',
        'Transmission Assets': 'Transmission Line',
        'Transmission': 'Transmission Substation',
        'Pipeline Assets': 'Pipeline',
        'Other Assets': 'Other'
    },
    tableDisclaimer: {
        label:
            '* Includes megawatts, pipeline miles or pipeline capacity associated with noncontrolling interests related to NextEra Energy Partners, LP.'
    },
    appFooterCopyrightText: {
        label: 'NextEra Energy, Inc. All Rights Reserved'
    },
    appFooterLinks: [
        {
            label: 'Forward-looking Statements',
            url:
                'http://www.nexteraenergy.com/sustainability/overview/about-this-report/cautionary-statements.html'
        },
        {
            label: 'Map Notes',
            url: 'http://www.nexteraenergy.com/company/portfolio-map/notes.html'
        },
        {
            label: 'Terms',
            url: 'http://www.nexteraenergy.com/legal-notice.html'
        },
        {
            label: 'Privacy Policy',
            url: 'http://www.nexteraenergy.com/privacy-policy.html'
        },
        {
            label: 'Safety Policy',
            url: 'http://www.nexteraenergy.com/safety-policy.html'
        }
    ],
    excludeLegendItems: [
        'Pipeline',
        'Transmission Line'
    ]
};
